const messagesCopyDepartments = () => {
  const messages = {
    searchPlaceholder: 'Buscar',
    noItemsMessage: 'Nenhum departamento',
    noneSelectedMessage: 'Nenhum departamento selecionado',
    selectedMessage: 'selecionado(s)',
    selectAllMessage: 'Selecionar Todos',
    clearAllMessage: 'Limpar Todos',
    disabledItemsTooltip: 'You can only select 1 file',
  }
  return messages
}

export default messagesCopyDepartments
